module.exports = __webpack_public_path__ + "img/Löschgruppe.e5675191.svg";